import { type LoaderFunctionArgs, replace } from 'react-router';
import { groupsQueryOptions } from '@/hooks/contacts/use-groups';
import { generateGroupInfoByQRCodeQueryOptions } from '@/hooks/scan-code/use-group-by-code';
import ROUTES from '@/routes';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export async function contactRequestGroupLoader({ request }: LoaderFunctionArgs) {
  const { searchParams } = new URL(request.url);

  const { code } = ROUTES.CONTACT.REQUEST.GROUP.$deserializeSearchParams(searchParams);

  if (!code) return replace(ROUTES.CONTACT.REQUEST.SCAN.$path());

  const groupInfo = await queryClient
    .ensureQueryData(generateGroupInfoByQRCodeQueryOptions(code))
    .catch(catchFetcherError);

  if (!groupInfo) return replace(ROUTES.CONTACT.REQUEST.SCAN.$path());

  const myGroups = await queryClient.fetchQuery(groupsQueryOptions);
  if (myGroups[groupInfo.GroupData.ID])
    return replace(ROUTES.MESSAGES.GROUPS.$buildPath({ params: { id: groupInfo.GroupData.ID } }));

  return {
    groupInfo,
  };
}
